import { List } from 'immutable';
import { notificationConstants } from 'constants/notification.constants';

export function notifications(state = {}, action) {
  switch (action.type) {
    case notificationConstants.NOTIFICATION_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case notificationConstants.NOTIFICATION_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case notificationConstants.NOTIFICATION_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };

    case notificationConstants.NOTIFICATION_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case notificationConstants.NOTIFICATION_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const notificationIndex = state.items.findIndex(val => val.id === action.response.id);

      if (notificationIndex === -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(notificationIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case notificationConstants.NOTIFICATION_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case notificationConstants.NOTIFICATION_DELETE_SUCCESS:
      return {
        ...state,
        items: state.items.filter(n => n.id !== action.notificationId)
      };
    case notificationConstants.NOTIFICATION_DELETE_FAILURE:
      return {
        ...state,
        deleteError: action.error
      };
    case notificationConstants.NOTIFICATION_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };

    default:
      return state;
  }
}
